import React, { useState, useRef } from 'react';
import '../UploadImage.css';
import { uploadImageToMedia } from '../Api';
import { toast } from 'react-toastify';

function UploadImage({ handleClose, contentPage }) {
    const [images, setImages] = useState([]);
    const [progress, setProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef(null);

    const handleFileSelect = (e) => {
        const selectedFiles = Array.from(e.target.files).slice(0, 2 - images.length);
        if (selectedFiles.length === 0 && images.length >= 2) {
            toast.warn('Maximum 10 images allowed');
            return;
        }
        setImages((prevImages) => [...prevImages, ...selectedFiles]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files).slice(0, 2 - images.length);
        if (droppedFiles.length === 0 && images.length >= 2) {
            toast.warn('Maximum 10 images allowed');
            return;
        }
        setImages((prevImages) => [...prevImages, ...droppedFiles]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    // Handle image upload
    const handleUpload = async (e) => {
        e.preventDefault();
        if (images.length === 0) {
            toast.error('Please select at least one image');
            return;
        }

        setIsUploading(true);
        try {
            const totalImages = images.length;
            let uploadedCount = 0;

            for (const image of images) {
                await uploadImageToMedia(image, contentPage, image.name);
                uploadedCount++;
                setProgress(Math.round((uploadedCount / totalImages) * 100));
                toast.success(`Image "${image.name}" uploaded successfully`);
            }

            setImages([]);
            setProgress(0);
            setIsUploading(false);
            handleClose(); 
        } catch (error) {
            console.error('Upload error:', {
                folderName: contentPage,
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            toast.error(error.message || 'Failed to upload images');
            setIsUploading(false);
        }
    };

    const triggerFileSelect = () => {
        fileInputRef.current.click();
    };

    const handleCancel = () => {
        setImages([]);
        setProgress(0);
        setIsUploading(false);
        handleClose();
    };

    return (
        <div className="layout-container">
            <div className="layout-content-container">
                <div className="upload-section">
                    <div
                        className="drag-drop-area"
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                    >
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            accept="image/*"
                            multiple
                            onChange={handleFileSelect}
                        />
                        <div className="drag-drop-text">
                            <p>Drag and drop to upload</p>
                            <p>You can add up to 2 images</p>
                            <p>{images.length} images selected</p>
                        </div>
                        <button className="select-button" onClick={triggerFileSelect}>
                            Select from computer
                        </button>
                    </div>
                </div>
                <div className="progress-section">
                    <div className="progress-header">
                        <p>{isUploading ? 'Uploading' : 'Upload Progress'}</p>
                    </div>
                    <div className="progress-bar-container">
                        <div
                            className="progress-bar"
                            style={{ width: `${progress}%` }}
                        ></div>
                    </div>
                    <p className="progress-text">{progress}%</p>
                </div>
                <div className="button-section">
                    <button
                        className="upload-button"
                        onClick={handleUpload}
                        disabled={isUploading || images.length === 0}
                    >
                        {isUploading ? 'Uploading...' : 'Upload'}
                    </button>
                    <button
                        style={{ background: 'red', margin: '0 0 0 20px' }}
                        className="upload-button"
                        onClick={handleCancel}
                        disabled={isUploading}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UploadImage;